import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index.less';

const defaultTitle = '您的申报已提交，您可以在“申报信息”查看已填写的申报';

export default function DeclareResult() {
  const Navigate = useNavigate();

  function toHome() {
    Navigate('/home');
  }

  return (
    <div className="declare-result">
      <div className="border" />
      <div className="declare-result__con">
        <div>
          <Result
            status="success"
            title={defaultTitle}
            extra={[
              <Button type="primary" key="console" onClick={toHome}>
                确定
              </Button>,
            ]}
          />
        </div>
      </div>
    </div>
  );
}
